import * as React from 'react';
import LottieView from 'react-lottie';
import { ContentView } from '@levelapp/softfabric';
import LottieWebViewStyle from './LottieWebViewStyle';
import LottieWebViewModel from './LottieWebViewModel';
export default class LottieWebView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding
        this.bind(new LottieWebViewModel(this), new LottieWebViewStyle(this));
    }
    /* RENDERING */
    render() {
        return (React.createElement(LottieView, { options: {
                loop: this.props.loop,
                autoplay: true,
                animationData: this.props.source
            }, isClickToPauseDisabled: true, height: this.props.height, width: this.props.width }));
    }
}
